import { SharingResult } from '@/app/models/sharingResult';
import { Data, getComparator } from '@/pages/buildingsTotal';
import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExpandableSharingDetailRow from './ExpandableSharingDetailRow';

type Order = 'asc' | 'desc';

const RowTableRow = styled(TableCell)(() => ({
  fontSize: 13,
  backgroundColor: 'white',
  borderBottom: 'none',
}));

interface SharingResultsTableProps {
  rows: SharingResult[] | null;
}

function SharingResultsTable(props: SharingResultsTableProps) {
  const { rows } = props;
  const { t } = useTranslation(['sharingDetail', 'common']);

  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<keyof Data>('value');
  const handleRequestSortGoals = (property: keyof Data) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const visibleRows = useMemo(() => {
    if (!rows) return [];
    const stabilized = [...rows];
    return stabilized.sort((a, b) => getComparator(order, 'value')(a, b));
  }, [rows, order]);

  return (
    <div style={{ display: 'flex', width: '100%', marginTop: '24px', marginBottom: '16px' }}>
      <div style={{ width: '100%' }}>
        <TableContainer sx={{ height: '25rem' }} component={Paper}>
          <Table stickyHeader size="small" aria-label="Expense Table">
            <TableHead sx={{ fontWeight: 700 }}>
              <TableRow>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {t('project')}
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  <TableSortLabel
                    active={orderBy === 'value'}
                    direction={orderBy === 'value' ? order : 'asc'}
                    onClick={() => handleRequestSortGoals('value')}
                    style={{ fontWeight: 'bold' }}
                  >
                    {t('value')}
                  </TableSortLabel>
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {t('operation')}
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {t('expense')}
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {t('supplier')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                // eslint-disable-next-line react/jsx-key
                rows && visibleRows.map((row: SharingResult) => <ExpandableSharingDetailRow row={row} />)
              }
              {rows?.length === 0 && (
                <RowTableRow>
                  <TableCell sx={{ textAlign: 'center' }} colSpan={8}>
                    {t('no.content.found')}
                  </TableCell>
                </RowTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default SharingResultsTable;
